import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  token,
  alert,
  Status,
  tokens,
  params,
  locale,
} from "../components/CustomComponent.js";
import jsPDF from "jspdf";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import LOGO from "../assets/images/logo.png";
import THUMBNAIL from "../assets/images/thumbnail.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_product: [],

      select_photo: 0,


      phone_contact: "",
      email_contact: "",

      photo: [],
      product_name: "",
      description: "",
      type: "",
      stove: "",
      size: "",
      weight: "",
      amount: "",
      ratio: "",
      chamber: "",
      temperature: "",
      fuel: "",
      aeration: "",
      lifespan: "",
      warranty: "",
    };
  }
  componentDidMount = async () => {
    loading(false);
      this.Get();
  };
  Get = async () => {
    loading(true);
    let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
    let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
    result = await response.json();
    localStorage.setItem("scp-acc-tk", JSON.stringify(result));
    }else{
      result = tokens;
    }
    let data_product = result?.product ? Object.values(result?.product) : [];
    this.setState({
       phone_contact:
              result?.setting[`${locale}_phone_contact`] ||
              result?.setting?.th_phone_contact,
            email_contact:
              result?.setting[`${locale}_email_contact`] ||
              result?.setting?.th_email_contact,
      data_product: data_product?.sort(() => Math.random() - 0.5)?.slice(0, 6),
      photo: data_product?.find((e) => e.uid == params("id")).photo,
      product_name: data_product?.find((e) => e.uid == params("id"))[`${locale}_product_name`] || data_product?.find((e) => e.uid == params("id"))?.th_product_name,
      description: data_product?.find((e) => e.uid == params("id"))[`${locale}_description`] || data_product?.find((e) => e.uid == params("id"))?.th_description,
      type: data_product?.find((e) => e.uid == params("id"))[`${locale}_type`] || data_product?.find((e) => e.uid == params("id"))?.th_type,
      stove: data_product?.find((e) => e.uid == params("id"))[`${locale}_stove`] || data_product?.find((e) => e.uid == params("id"))?.th_stove,
      size: data_product?.find((e) => e.uid == params("id"))[`${locale}_size`] || data_product?.find((e) => e.uid == params("id"))?.th_size,
      weight: data_product?.find((e) => e.uid == params("id"))[`${locale}_weight`] || data_product?.find((e) => e.uid == params("id"))?.th_weight,
      amount: data_product?.find((e) => e.uid == params("id"))[`${locale}_amount`] || data_product?.find((e) => e.uid == params("id"))?.th_amount,
      ratio: data_product?.find((e) => e.uid == params("id"))[`${locale}_ratio`] || data_product?.find((e) => e.uid == params("id"))?.th_ratio,
      chamber: data_product?.find((e) => e.uid == params("id"))[`${locale}_chamber`] || data_product?.find((e) => e.uid == params("id"))?.th_chamber,
      temperature: data_product?.find((e) => e.uid == params("id"))[`${locale}_temperature`] || data_product?.find((e) => e.uid == params("id"))?.th_temperature,
      fuel: data_product?.find((e) => e.uid == params("id"))[`${locale}_fuel`] || data_product?.find((e) => e.uid == params("id"))?.th_fuel,
      aeration: data_product?.find((e) => e.uid == params("id"))[`${locale}_aeration`] || data_product?.find((e) => e.uid == params("id"))?.th_aeration,
      lifespan: data_product?.find((e) => e.uid == params("id"))[`${locale}_lifespan`] || data_product?.find((e) => e.uid == params("id"))?.th_lifespan,
      warranty: data_product?.find((e) => e.uid == params("id"))[`${locale}_warranty`] || data_product?.find((e) => e.uid == params("id"))?.th_warranty,
    });
    loading(false);
  };
  loadImage(src) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.src = src;
  });
}
  exportPDF = async () => {
  const { photo } = this.state;
  const pdf = new jsPDF("p", "px", "a4");

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  for (let i = 0; i < photo.length; i++) {
    const img = await this.loadImage(photo[i]);

    const imgRatio = img.width / img.height;
    const pageRatio = pageWidth / pageHeight;

    let renderWidth, renderHeight;

    if (imgRatio > pageRatio) {
      // ภาพกว้าง → fit width
      renderWidth = pageWidth;
      renderHeight = pageWidth / imgRatio;
    } else {
      // ภาพสูง → fit height
      renderHeight = pageHeight;
      renderWidth = pageHeight * imgRatio;
    }

    const x = (pageWidth - renderWidth) / 2;
    const y = (pageHeight - renderHeight) / 2;

    pdf.addImage(
      img,
      "PNG",
      x,
      y,
      renderWidth,
      renderHeight
    );

    if (i < photo.length - 1) {
      pdf.addPage();
    }
  }

  pdf.save("output.pdf");
};

  render() {
    const {
      phone_contact,
email_contact,
      data_product,
      select_photo,
      photo,
      product_name,
      description,
      type,
      stove,
      size,
      weight,
      amount,
      ratio,
      chamber,
      temperature,
      fuel,
      aeration,
      lifespan,
      warranty,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />
        <div className="hpx-50"></div>
        <div className="container">
          <div className="row">
            <div className="col-12 col-xl-5 mb-4">
              <div className="row mb-3">
                <div className="col-12 mb-4">
                  <img
                    alt="THUMBNAIL"
                    src={photo[select_photo] || THUMBNAIL}
                    className="h-100 w-100 rounded-3"
                    style={{ objectFit: "cover", minHeight: 300 }}
                    loading="lazy"
                  />
                </div>
                <div className="col-12 mb-4 d-flex d-md-block flex-wrap">
                  {photo?.map((item, index) => (
                    <img
                      alt="THUMBNAIL"
                      src={item}
                      className="hpx-100 w-100 rounded-3 mb-3 me-3 pointer"
                      loading="lazy"
                      style={{
                        objectFit: "cover",
                        maxWidth: 100,
                        opacity: select_photo === index ? 1 : 0.4,
                      }}
                      onClick={() => {
                        this.setState({ select_photo: index });
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className="col-12 col-xl-7 mb-4">
                <h3 className="fw-bold">{product_name}</h3>

              <hr/>
                <h5 className="fw-bold mb-4">คำอธิบาย</h5>
                <span>{description.split('\n').map((line, i) => <p style={{textIndent:50, textAlign:"justify"}} key={i}>{line}</p>)}</span>
              <hr/>
                <h5 className="fw-bold mb-4">หากสนใจสามารถติดต่อได้ที่</h5>
                <button className="btn btn-primary wpx-40 hpx-40 me-2" onClick={()=>{
                   window.open("mailto:"+email_contact.split(",")[0],"_blank")
                }}><span className="icon">{"\uf0e0"}</span></button>
                <button className="btn btn-dark wpx-40 hpx-40 me-2" onClick={()=>{
                  window.open("tel:"+phone_contact.split(",")[0],"_blank")
                }}><span className="icon">{"\uf095"}</span></button>
              <hr/>
                <h5 className="fw-bold mb-4">คุณสมบัติทั่วไป</h5>
              <table className="table table-striped rounded-3 overflow-hidden w-100 mb-3">
                <thead>
                  <tr className="fw-bold">
                    <td>ข้อมูลทั่วไป</td>
                    <td>คุณสมบัติเฉพาะ รุ่น</td>
                  </tr>
                </thead>
                <tbody>
                  {stove && (
                  <tr>
                    <td>ระบบของเตา :</td>
                    <td>{stove}</td>
                  </tr>
                  )}
                  {size && (
                  <tr>
                    <td>ขนาด (ประมาณ) :</td>
                    <td>{size}</td>
                  </tr>
                  )}
                  {weight && (
                  <tr>
                    <td>น้ำหนัก (ประมาณ) :</td>
                    <td>{weight}</td>
                  </tr>
                  )}
                  {amount && (
                  <tr>
                    <td>ปริมาณที่เผาได้/ ชม. :</td>
                    <td>{amount}</td>
                  </tr>
                  )}
                  {ratio && (
                  <tr>
                    <td>อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง) :</td>
                    <td>{ratio}</td>
                  </tr>
                  )}
                  {chamber && (
                  <tr>
                    <td>ห้องเผาไหม้ :</td>
                    <td>{chamber}</td>
                  </tr>
                  )}
                  {temperature && (
                  <tr>
                    <td>อุณหภูมิในขณะเผาไหม้ :</td>
                    <td>{temperature}</td>
                  </tr>
                  )}
                  {fuel && (
                  <tr>
                    <td>เชื้อเพลิงในการเผาไหม้ :</td>
                    <td>{fuel}</td>
                  </tr>
                  )}
                  {aeration && (
                  <tr>
                    <td>ระบบเติมอากาศ :</td>
                    <td>{aeration}</td>
                  </tr>
                  )}
                  {lifespan && (
                  <tr>
                    <td>อายุการใช้งาน :</td>
                    <td>{lifespan}</td>
                  </tr>
                  )}
                  {warranty && (
                  <tr>
                    <td>การรับประกัน :</td>
                    <td>{warranty}</td>
                  </tr>
                  )}
                </tbody>
              </table>
              <button className="btn btn-primary px-4 mb-3" onClick={() => { this.exportPDF()}}>
                ดาวน์โหลดแคตตาล็อก
              </button>
            </div>
            <div className="col-12 mb-4">
              <hr/>
              <div className="d-flex justify-content-start align-items-center mt-5 mb-2 mx-4">
                <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
                <h5 className="fw-bold mb-0 mx-3">สินค้าอื่นๆ</h5>
                <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
              </div>
               <div className="row container mx-auto mt-4 mb-2 justify-content-center">
            {data_product.map((item, index) => (
              <div
                className={
                  "col-12 col-sm-6 col-lg-4 col-xl-3 mb-3 p-1 product pointer" +
                  (index > 3 ? " d-none d-lg-block d-xl-none" : "")
                }
                onClick={() => {
                  window.location.href = "/detail-product?id=" + item.uid;
                }}
              >
                <div className="w-100 hpx-400 bg-light d-flex align-items-center justify-content-center position-relative rounded-3 overflow-hidden mb-3 shadow-sm">
                  {item.photo[0] ? (
                    <img
                      alt="LOGO"
                      src={item.photo[0]}
                      className="h-100 w-100 mx-auto my-5"
                      style={{ objectFit: "cover" }}
                      loading="lazy"
                    />
                  ) : (
                    <img
                      alt="LOGO"
                      src={THUMBNAIL}
                      className="h-100 w-75 mx-auto my-5"
                      style={{ objectFit: "contain" }}
                      loading="lazy"
                    />
                  )}
                </div>

                <h6
                  className="fw-bold w-100 overflow-hidden mb-2 text-nowrap"
                  style={{ textOverflow: "ellipsis" }}
                >
                  {item[`${locale}_product_name`] || item.th_product_name || ""}
                </h6>
                <small
                  className="text-secondary"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item[`${locale}_description`] || item.th_description || ""}
                </small>
                <button className="btn btn-primary px-4 mt-3">
                  รายละเอียด
                </button>
              </div>
            ))}
          </div>
            </div>
          </div>
        </div>
        <div className="hpx-50"></div>
        <Footer />
      </div>
    );
  }
}
